import type { ReactNode } from 'react'
import { Tooltip } from '@/components/ui/Tooltip'
import { cn } from '@/lib/utils'

export type InvoiceStatus =
  | 'concept'
  | 'approval'
  | 'approved'
  | 'sent'
  | 'escalated'
  | 'paid'
  | 'overdue'
  | 'closed'

interface StatusMeta {
  label: string
  dot: string
  text?: string
}

const STATUS: Record<InvoiceStatus, StatusMeta> = {
  concept: { label: 'Concept', dot: 'bg-status-concept' },
  approval: { label: 'Ter approval', dot: 'bg-status-approval' },
  approved: { label: 'Approved', dot: 'bg-status-approved' },
  sent: { label: 'Verzonden', dot: 'bg-status-sent' },
  escalated: { label: 'Geëscaleerd', dot: 'bg-status-overdue', text: 'text-status-overdue' },
  paid: { label: 'Betaald', dot: 'bg-status-paid' },
  overdue: { label: 'Te lang open', dot: 'bg-status-overdue', text: 'text-status-overdue' },
  // Afgesloten facturen vragen geen aandacht meer, dus gedempt in plaats van rood.
  closed: { label: 'Afgesloten', dot: 'bg-status-closed', text: 'text-ink-faint' },
}

export function StatusPill({
  status,
  className,
  labelOverride,
  hint,
}: {
  status: InvoiceStatus
  className?: string
  labelOverride?: string
  hint?: ReactNode
}) {
  const meta = STATUS[status]
  const pill = (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md bg-fill-1 px-2 py-0.5 text-xs font-medium ring-1 ring-inset ring-hairline',
        meta.text ?? 'text-ink-soft',
        hint ? 'cursor-help' : undefined,
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', meta.dot)} />
      {labelOverride ?? meta.label}
    </span>
  )

  return hint ? <Tooltip content={hint}>{pill}</Tooltip> : pill
}
